"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { UploadDocument } from "../Icons";

interface DropzoneUploaderProps {
	onFileSelect: (file: File) => void;
	dragActive: boolean;
	setDragActive: (active: boolean) => void;
	triggerFileInput: () => void;
	fileInputRef: React.RefObject<HTMLInputElement>;
	selectedFile: File | null;
}

const DropzoneUploader: React.FC<DropzoneUploaderProps> = ({
	onFileSelect,
	dragActive,
	setDragActive,
	triggerFileInput,
	fileInputRef,
	selectedFile,
}) => {
	const handleDrag = (e: React.DragEvent) => {
		e.preventDefault();
		e.stopPropagation();
		if (e.type === "dragenter" || e.type === "dragover") {
			setDragActive(true);
		} else if (e.type === "dragleave") {
			setDragActive(false);
		}
	};

	const handleDrop = (e: React.DragEvent) => {
		e.preventDefault();
		e.stopPropagation();
		setDragActive(false);

		if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
			onFileSelect(e.dataTransfer.files[0]);
		}
	};

	const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (e.target.files && e.target.files.length > 0) {
			onFileSelect(e.target.files[0]);
		}
	};

	return (
		<div
			className={`border-2 border-dashed rounded-lg p-8 flex flex-col items-center justify-center bg-blue-50 ${
				dragActive ? "border-blue-500" : "border-blue-300"
			} ${selectedFile ? "border-green-500 bg-green-50" : ""}`}
			onDragEnter={handleDrag}
			onDragLeave={handleDrag}
			onDragOver={handleDrag}
			onDrop={handleDrop}>
			<input
				ref={fileInputRef}
				type="file"
				className="hidden"
				onChange={handleFileChange}
				accept=".pdf,.doc,.docx,.txt,.png,.jpg,.jpeg"
			/>
			<UploadDocument />
			<p className="py-4 ff_poppins text-sm leading-[21px] text-center text-[#364261]">
				{selectedFile
					? `File selected: ${selectedFile.name}`
					: "Drag and Drop File here or"}
			</p>
			<Button
				type="button"
				variant="outline"
				className="mt-2 cursor-pointer border-blue-500 text-blue-500 ff_poppins"
				onClick={triggerFileInput}>
				Browse File
			</Button>
		</div>
	);
};

export default DropzoneUploader;
